import { FC, Fragment, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { Schedule2 } from "../../../../../../services/cloudchipr.api";
import { ScheduleListGridActionCellFunctionality } from "../../../common/list/action-cell/ScheduleListGridActionCellFunctionality";
import { WithoutAccountsWorkflowDialog } from "../WithoutAccountsWorkflowDialog";
import { useDialog } from "../../../../../../utils/hooks/useDialog.hook";
import { useAppDispatch, useAppSelector } from "../../../../../../store/hooks";
import { toggleScheduledJobsStatusThunk } from "../../../../../../store/schedules/thunks/toggleScheduledJobsStatusThunk";
import { scheduleStatusToggleLoadingSelector } from "../../../../../../store/schedules/selectors/scheduleStatusToggleLoadingSelector";

type ScheduledJobsListGridActionCellProps = {
  schedule: Schedule2;
};

export const ScheduledJobsDataGridActionCell: FC<
  ScheduledJobsListGridActionCellProps
> = ({ schedule }) => {
  const { open, openDialog, closeDialog } = useDialog();

  const dispatch = useAppDispatch();
  const loading = useAppSelector(scheduleStatusToggleLoadingSelector);
  const navigate = useNavigate();

  const editScheduleHandler = useCallback(() => {
    const withoutAccounts = schedule.accounts.every(
      (account) => account.status !== "connected",
    );

    if (withoutAccounts) {
      openDialog();
    } else {
      navigate(`/schedule/classic/edit/${schedule.id}`);
    }
  }, [schedule, navigate, openDialog]);

  const deleteScheduleHandler = useCallback(async () => {
    try {
      await dispatch(
        toggleScheduledJobsStatusThunk({
          schedule: schedule as Schedule2,
          status: "deleted",
        }),
      ).unwrap();

      enqueueSnackbar("Workflow successfully deleted.", {
        variant: "snackbarAlert",
        AlertSnackBarProps: { severity: "success" },
      });
    } catch (e) {
      // @ts-expect-error // todo: api fix
      enqueueSnackbar(e?.data?.message || "Something went wrong.", {
        variant: "snackbarAlert",
        AlertSnackBarProps: { severity: "error" },
      });
    }
  }, [schedule, dispatch]);

  return (
    <Fragment>
      <ScheduleListGridActionCellFunctionality
        isLoading={!!loading}
        name={schedule.name}
        id={schedule.id}
        onEdit={editScheduleHandler}
        onDelete={deleteScheduleHandler}
        type="workflow"
      />

      {open && (
        <WithoutAccountsWorkflowDialog
          onClose={closeDialog}
          workflow={schedule}
        />
      )}
    </Fragment>
  );
};
